<template>
  <v-app>
    <dashboard-core-app-bar v-if="showDashboard" />

    <dashboard-core-drawer
      v-if="!showHome"
    />

    <dashboard-core-view />

    <dashboard-core-footer v-if="showHome"/>
  
    <!-- <dashboard-core-settings /> -->
  </v-app>
</template>

<script>
  import { mapState } from 'vuex'
  import DashboardCoreAppBar from '@/views/dashboard/components/core/AppBar'
  import DashboardCoreDrawer from '@/views/dashboard/components/core/Drawer'
  import DashboardCoreView from '@/views/dashboard/components/core/View'
  import DashboardCoreFooter from '@/views/dashboard/components/core/Footer'


  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar,
      DashboardCoreDrawer,
      DashboardCoreView,
      DashboardCoreFooter
    },

    data: () => ({
      expandOnHover: false,
    }),

    computed: {
      ...mapState(['routesName']),

      showHome () {
        return this.routesName.includes(this.$route.name)
      },

      showDashboard () {
        return this.$route.name !== 'RegisterStudent'
      },

    },

  }
</script>
